import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@frontend/lib/theme";
import { RefreshProvider } from "@frontend/lib/refresh";
import { ViewerProvider } from "@frontend/lib/viewer";
import { App } from "./App";
import "@frontend/styles/globals.css";

document.documentElement.style.setProperty(
  "--font-geist-sans",
  '"Geist", ui-sans-serif, system-ui, sans-serif',
);
document.documentElement.style.setProperty(
  "--font-geist-mono",
  '"Geist Mono", ui-monospace, monospace',
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <RefreshProvider>
          <ViewerProvider>
            <App />
          </ViewerProvider>
        </RefreshProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
